<template>
  <div class="page_ table_textc">
    <a-table
      style="margin-top: 17px;"
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      @change="handlePageChange"
      class="table_b"
    >
      <span slot="operation" slot-scope="text, record" class="span_btn">
        <a :href="record.payUrl">去支付</a>
      </span>
    </a-table>
  </div>
</template>
<style lang="scss" scoped>
.table_b {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
<script>
import api from "@/utils/api";
import navbar from "../components/navbar";
const columns = [
  {
    title: "保单号",
    key: "applyPolicyNo",
    dataIndex: "applyPolicyNo",
  },
  {
    title: "投保人",
    key: "holderName",
    dataIndex: "holderName",
  },
  {
    title: "被保人",
    key: "insuredName",
    dataIndex: "insuredName",
  },
  {
    title: "产品名称",
    key: "productName",
    dataIndex: "productName",
  },
  {
    title: "金额",
    key: "amount",
    dataIndex: "amount",
  },
  {
    title: "创建时间",
    key: "createDate",
    dataIndex: "createDate",
  },
  {
    title: "操作",
    key: "1",
    scopedSlots: { customRender: "operation" },
  },
];

export default {
  data() {
    document.title = "订单管理";
    return {
      columns,
      tableData: [],
      pagination: {
        total: 0,
        pageSize: 20,
        pageNum: 1,
      },
      pageNum: "1",
      pageSize: "20",
      userId:''
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    handlePageChange(e) {
      this.pageNum = e.current;
      this.initData();
    },
    initData() {
     api.getUserId().then((res) => {
        if (res.data.returnCode === "0000") {
          this.userId=res.data.data
          api.queryUnPayInfo({userId:this.userId}).then((res) => {

          })
        }
      });
    },
  },
};
</script>
